/**
 * @generated SignedSource<<6d3bc9c3c5a41aac7fd43017ae7c0487>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventVisibility = "LISTED" | "UNLISTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventCardNew_event$data = {
  readonly attendeesByRelevance?: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventAttendeesOverlap_eventAttendees">;
  };
  readonly attendingCount?: {
    readonly totalCount: number;
  };
  readonly coverPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly eventCardOwner: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly primaryPhoto: {
      readonly rowId: string;
    } | null | undefined;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
  } | {
    readonly __typename: "User";
    readonly firstName: string;
    readonly lastName: string;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly name: string;
  readonly prettyUrl: string;
  readonly startAt: string;
  readonly updatedAt: string | null | undefined;
  readonly visibility: EventVisibility;
  readonly waitingCount?: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_event">;
  readonly " $fragmentType": "EventCardNew_event";
};
export type EventCardNew_event$key = {
  readonly " $data"?: EventCardNew_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardNew_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAttendRow"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardNew_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "w": 500
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":500})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "eventCardOwner",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "primaryPhoto",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GuildPrimaryPhotoNew_guild"
            }
          ],
          "type": "Guild",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "UserPrimaryPhotoNew_user"
            }
          ],
          "type": "User",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "includeAttendRow",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "attendeesByRelevance",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "status": {
                  "in": [
                    "ATTENDING_IN_PERSON",
                    "ATTENDING_VIRTUAL",
                    "WAITING_IN_PERSON",
                    "WAITING_VIRTUAL"
                  ]
                }
              }
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "EventAttendeesConnection",
          "kind": "LinkedField",
          "name": "eventAttendeesByRelevance",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventAttendeesOverlap_eventAttendees"
            }
          ],
          "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:5)"
        },
        {
          "alias": "attendingCount",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "status": {
                  "in": [
                    "ATTENDING_IN_PERSON",
                    "ATTENDING_VIRTUAL"
                  ]
                }
              }
            }
          ],
          "concreteType": "EventAttendeesConnection",
          "kind": "LinkedField",
          "name": "eventAttendees",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
        },
        {
          "alias": "waitingCount",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "status": {
                  "in": [
                    "WAITING_IN_PERSON",
                    "WAITING_VIRTUAL"
                  ]
                }
              }
            }
          ],
          "concreteType": "EventAttendeesConnection",
          "kind": "LinkedField",
          "name": "eventAttendees",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventAttendButtonNew_event"
        }
      ]
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "78e6a11424ecda3ec5166fefb087238d";

export default node;
